import { isExperimentActive } from '../../utils/experiments';
import { servicesCardsTextsExperimentGroups, servicesCardsTextsExperimentName } from '../../constants/experiments';
import { createSelector } from 'reselect';
import { selectExperiments } from './selectExperiments';

export const selectRedesignServiceCardsExperiment = createSelector([selectExperiments], experiments => {
  return isExperimentActive(experiments, servicesCardsTextsExperimentName, servicesCardsTextsExperimentGroups.redesign);
});
